import { Table, Tag, Typography } from 'antd';
import React from 'react';
import { DATE_FORMATS } from '../../../../../../common/constants';
import { formatDate } from '../../../../../../common/utils';
import { isOrderItemFailed } from '../../../../hooks/useToyScheduleOrders';

const { Text } = Typography;

const renderDate = (value) =>
  value ? formatDate(value, DATE_FORMATS?.REGULAR) : '-';

const renderOrderNumber = (item) =>
  !isOrderItemFailed(item) && item?.orderNumber ? (
    <Text copyable>{item?.orderNumber}</Text>
  ) : (
    '-'
  );

const OrderResultsTable = ({ items = [] }) => {
  const columns = [
    {
      title: 'Toy #',
      dataIndex: 'toyNumber',
      key: 'toyNumber',
      width: 140,
      render: (value) => value || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (value, item) => (
        <Tag color={isOrderItemFailed(item) ? 'red' : 'green'}>
          {value || (isOrderItemFailed(item) ? 'FAILED' : 'DONE')}
        </Tag>
      ),
    },
    {
      title: 'Order #',
      key: 'orderNumber',
      render: (_, item) => renderOrderNumber(item),
    },
    {
      title: 'Week Start',
      dataIndex: 'weekStartDate',
      key: 'weekStartDate',
      width: 110,
      render: renderDate,
    },
    {
      title: 'Delivery',
      dataIndex: 'expectedDeliveryDate',
      key: 'expectedDeliveryDate',
      width: 110,
      render: renderDate,
    },
  ];

  return (
    <Table
      size="small"
      tableLayout="fixed"
      columns={columns}
      dataSource={items}
      rowKey={(item, index) =>
        `${item?.orderNumber || ''}-${item?.toyNumber || ''}-${index}`
      }
      pagination={false}
      locale={{ emptyText: 'The backend returned no item results.' }}
    />
  );
};

export default OrderResultsTable;
